'use client';

import type React from 'react';

interface SortableHeaderProps {
  children: React.ReactNode;
  sortKey: string;
  currentSort: { key: string; direction: 'asc' | 'desc' } | null;
  onSort: (key: string) => void;
  align?: 'left' | 'right';
}

export const SortableHeader = ({
  children,
  sortKey,
  currentSort,
  onSort,
  align = 'left',
}: SortableHeaderProps) => {
  const isActive = currentSort?.key === sortKey;
  const direction = isActive ? currentSort.direction : null;

  return (
    <th
      className={`px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none ${
        align === 'right' ? 'text-right' : 'text-left'
      }`}
      onClick={() => onSort(sortKey)}
    >
      <div
        className={`flex items-center gap-1 ${align === 'right' ? 'justify-end' : 'justify-start'}`}
      >
        <span>{children}</span>
        <div className='flex flex-col'>
          <svg
            className={`w-3 h-3 ${
              isActive && direction === 'asc' ? 'text-blue-600' : 'text-gray-300'
            } transition-colors`}
            fill='currentColor'
            viewBox='0 0 20 20'
            aria-label='Sort ascending'
          >
            <title>Sort ascending</title>
            <path
              fillRule='evenodd'
              d='M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z'
              clipRule='evenodd'
            />
          </svg>
          <svg
            className={`w-3 h-3 -mt-1 ${
              isActive && direction === 'desc' ? 'text-blue-600' : 'text-gray-300'
            } transition-colors`}
            fill='currentColor'
            viewBox='0 0 20 20'
            aria-label='Sort descending'
          >
            <title>Sort descending</title>
            <path
              fillRule='evenodd'
              d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
              clipRule='evenodd'
            />
          </svg>
        </div>
      </div>
    </th>
  );
};
